<form (ngSubmit)="print()" [formGroup]="form">
	<h1 mat-dialog-title>
		<span *ngIf="data?.shipmentType === 'OnDemand'">{{'printReceiptModalView.orderLabel' | translate}}</span>
		<span *ngIf="data?.shipmentType === 'Routed'">{{'printReceiptModalView.stopModal' | translate}}</span>
		<span> {{data.id}} {{'printReceiptModalView.printOptionsLabel' | translate}}</span>
	</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<app-toggle-all [checkboxesFormGroup]="form" [checkboxes]="checkboxes"></app-toggle-all>
			<mat-checkbox #checkbox color="primary" formControlName="hideDestinationAddress">
				{{'printReceiptModalView.hideDestinationAddressLabel' | translate}}
			</mat-checkbox>
			<mat-checkbox #checkbox color="primary" formControlName="hideLogo">
				{{'printReceiptModalView.hideLogoLabel' | translate}}
			</mat-checkbox>
			<mat-checkbox #checkbox color="primary" formControlName="hideOriginAddress">
				{{'printReceiptModalView.hideOriginAddressLabel' | translate}}
			</mat-checkbox>
			<mat-checkbox #checkbox color="primary" formControlName="hideParcelInfo">
				{{'printReceiptModalView.hideParcelInfoLabel' | translate}}
			</mat-checkbox>
			<mat-checkbox #checkbox *ngIf="data?.shipmentType === 'OnDemand'" color="primary"
						  formControlName="hideRating">
				{{'printReceiptModalView.hideRatingLabel' | translate}}
			</mat-checkbox>
			<mat-checkbox #checkbox color="primary" formControlName="hideRequiredDriverInputs">
				{{'printReceiptModalView.hideRequiredDriverInputsLabel' | translate}}
			</mat-checkbox>
			<mat-checkbox #checkbox color="primary" formControlName="hideSignature">
				{{'printReceiptModalView.hideSignatureLabel' | translate}}
			</mat-checkbox>
			<mat-checkbox #checkbox color="primary" formControlName="hideStatusCodes">
				{{'printReceiptModalView.hideStatusCodesLabel' | translate}}
			</mat-checkbox>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			<span>{{'printReceiptModalView.cancelLabel' | translate}}</span>
		</button>
		<button [color]="'primary'" mat-raised-button type="submit">
			<span>{{'printReceiptModalView.printLabel' | translate}}</span>
		</button>
	</mat-dialog-actions>
</form>

<!-- This is not displayed unless printed -->
<app-receipt
		*ngIf="isReceiptReady"
		[hideParcelInfo]="form?.get('hideParcelInfo')?.value"
		[hideRating]="form?.get('hideRating')?.value"
		[hideSignature]="form?.get('hideSignature')?.value"
		[hideStatusCodes]="form?.get('hideStatusCodes')?.value"
		[hideDestinationAddress]="form?.get('hideDestinationAddress')?.value"
		[hideOriginAddress]="form?.get('hideOriginAddress')?.value"
		[hideLogo]="form?.get('hideLogo')?.value"
		[hideRequiredDriverInputs]="form?.get('hideRequiredDriverInputs')?.value"
		[id]="data?.id"
		[shipmentType]="data?.shipmentType"
		[mode]="data?.mode"
		[bulkReportData]="data?.reportData"
		[shouldLoadData]="shouldLoadData"
		(dataLoaded)="onDataLoaded()"
		class="hide"
		id="receipt">
</app-receipt>
